import React from "react";

import SearchComponent from "../../components/SearchComponent/SearchComponent";

function Homepage() {
  return (
    <div>
      <SearchComponent />
    </div>
  );
}

export default Homepage;
